import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "react-bootstrap";
import moment from "moment";
import { getChatMessageContent } from "../../../utils/helpers/chatMessageContent";
import SearchNoResultSmileIcon from "../../../assets/icons/meh.svg";
import { SearchConversationOnGroup } from "../../../redux/actions/chatActions";
import smallSaidIcon from "../../../assets/icons/smaliSaidIcon.svg";
import SearchConversationIcon from "../../../assets/images/SearchConversesionIcon.svg";
import xCircle from "../../../assets/icons/x-circle.svg";
import NoResults from "./NoResults";

const SearchConversation = ({
  fetchTransChatList,
  selectedCurrentRoomGroupId,
  chatConversationsType,
  setRightSideMenuStat,
  setChatConversationsType,
  setSearchConversation,
}) => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const currentUserId = window.localStorage.getItem("userid");
  const t = (key) => fetchTransChatList?.[key] || "";

  const [state, setState] = useState({
    querystringChat: "",
    searchConversationData: [],
  });

  const SearchConversationOnGroupReq = useSelector(
    (state) => state.chat.SearchConversationOnGroup
  );

  useEffect(() => {
    if (SearchConversationOnGroupReq?.status === true) {
      setState((prevState) => ({
        ...prevState,
        searchConversationData: SearchConversationOnGroupReq?.data,
      }));
    }
  }, [SearchConversationOnGroupReq]);

  useEffect(() => {
    if (state.querystringChat) {
      dispatch(
        SearchConversationOnGroup(
          selectedCurrentRoomGroupId,
          state.querystringChat
        )
      );
    }
  }, [state.querystringChat]);

  const goToSearchText = (item) => {
    let textClicked = item?.messageid;

    if (containerRef && containerRef.current) {
      const element = containerRef.current;

      [].forEach.call(element.childNodes, function (btn) {
        setTimeout(function () {
          btn.classList.remove("findSelected");
        }, 5000);
      });

      const elementsWithClass = element.querySelectorAll(`.div-${textClicked}`);
      elementsWithClass[0].classList.add("findSelected");
      element.scroll({
        top: elementsWithClass[0].offsetTop - 100,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const GetHighlightedText = ({ text, highlight }) => {
    const textFormat = getChatMessageContent(text).getPlainText();
    const parts = textFormat.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts.map((part, i) => (
          <span
            key={i}
            style={
              part.toLowerCase() === highlight.toLowerCase()
                ? { fontWeight: "bold" }
                : {}
            }
          >
            {part}
          </span>
        ))}
      </span>
    );
  };

  const handleClearSearch = () => {
    setState((prevState) => ({
      ...prevState,
      querystringChat: "",
    }));
    setRightSideMenuStat(false);
    setChatConversationsType(false);
    setSearchConversation(false);
  };

  return (
    <div className="left-menu-height" style={{ backgroundColor: "#FFFFFF" }}>
      <div className="search-text-chat px-3 pt-2 pb-1">
        <div className="d-flex justify-content-between">
          <p>
            {chatConversationsType === "Group"
              ? t("Search in the conversation")
              : t("Search in the conversation")}
          </p>
          <img
            src={xCircle}
            width={21}
            height={21}
            alt="#"
            onClick={handleClearSearch}
            className="cursor-pointer"
          />
        </div>
        <div className="d-flex align-items-center py-1">
          <Image src={SearchConversationIcon} alt="#" width={17} height={17} />
          <input
            type="text"
            style={{
              outline: "none",
              margin: "0 0 0 0px",
              fontWeight: state.querystringChat ? "400" : "400",
              color: state.querystringChat ? "#333333" : "#333333",
              fontSize: "12px",
            }}
            placeholder={t("Search or Start a conversation")}
            className="search-style ms-2"
            value={state.querystringChat}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                querystringChat: e.target.value.toLowerCase(),
              }))
            }
          />
        </div>
      </div>
      <div className="chat-people-block px-3">
        {state.querystringChat && state.searchConversationData?.length ? (
          state.searchConversationData.map((message, i) => (
            <div
              className="pb-2"
              key={message?.messageid}
              onClick={() => goToSearchText(message, i)}
            >
              <div
                style={{
                  fontSize: "11px",
                  lineHeight: "21px",
                  color: "#333333",
                }}
              >
                {moment(message?.messagetime).format("DD.MM.YYYY")}
              </div>
              <div className="d-flex gap-1">
                <div
                  style={{
                    fontSize: "12px",
                    lineHeight: "14px",
                    color: "#333333",
                    fontWeight: "bold",
                  }}
                >
                  {message?.senderid === currentUserId
                    ? "You"
                    : message?.sendername}
                  :
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    lineHeight: "14px",
                    color: "#333333",
                  }}
                >
                  <GetHighlightedText
                    text={message?.messagetext}
                    highlight={state.querystringChat}
                  />
                </div>
              </div>
              <div className="people-inbox-under"></div>
            </div>
          ))
        ) : state.querystringChat &&
          state.searchConversationData?.length <= 0 ? (
          <NoResults
            icon={SearchNoResultSmileIcon}
            t={t}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SearchConversation;
